export default "/app/themes/majeures/build/images/header.svg?84b90636d9a150279ec6a481e4c74665";